$( document ).ready(function() {
  
  // SEARCH
  $('.search-input-text').focus(function(){  
    $(this).addClass('focus');
    $("#logo").addClass("move");
  });
  $(".search-input-text").blur(function(){
    $(this).removeClass('focus');
    $("#logo").removeClass("move");
  });
  var value = $('.search-input-text').val();
  if (value !== '') {
    $('.search-input-text').addClass('superfocus');
    $("#logo").addClass("supermove");
  }
  $('.search-input-text').keyup(function () {
    var value = jQuery(this).val();
    if (value !== '') {
      $('.search-input-text').addClass('superfocus');
      $("#logo").addClass("supermove");
    } else {
      $('.search-input-text').removeClass('superfocus');
      $("#logo").removeClass("supermove");
    }
  });

  // HOMEPAGE RANDOM POSITIONING FEATURED PRODUCTS
  var classes = ["top", "center", "bottom"];
  $(".featured-product-silhouette").each(function(){
      $(this).addClass(classes[~~(Math.random()*classes.length)]);
  });
  
  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
      $("body").removeClass("fade-out");
    }, 500);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // FAILSAFE: always ensure page isn't left "locked" (fade, modal, overflow)
  function unlockBodyUI() {
    $("body")
      .removeClass("fade-out modal-open overflow-hidden")
      .css("overflow", ""); // reset to stylesheet default
  }

  // Run on load + safety timeout
  window.addEventListener("load", unlockBodyUI);
  setTimeout(unlockBodyUI, 2000);


  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          setTimeout(function(){
            l.classList.remove('lazy');
          }, 500);
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }
    
  // CLICK
  $( ".quick-buy-trigger" ).click(function() {
    $(this).next().show();
    $(this).prev().hide();
  });

  $( ".product" ).hover(
    function() {
    }, function() {
      $( this ).find( ".heart" ).show();
      $( this ).find( ".quick-buy-content" ).hide();
    }
  );

  $( "#mobile-menu-trigger" ).click(function() {
    $("#menu-mobile").toggleClass("show");
    $("#mini-cart").removeClass("active"); 
  });

  // EACH
  $('.product-info').each(function() {
    $($(this).prop('firstChild')).wrap('<h3>');
  });
  
 // PDP MOBILE
  // $( ".legal-content.faq h3" ).click(function() {
  //   $(this).toggleClass("show");
  //   $(this).next().slideToggle(300);
  // });

  // PDP FAQ accordion
// $(".legal-content.faq h3").click(function () {
//   var $clickedTitle = $(this);
//   var $clickedContent = $clickedTitle.next();

  // Close all other FAQ items
  // $(".legal-content.faq h3").not($clickedTitle).removeClass("show");
  // $(".legal-content.faq h3").not($clickedTitle).next().slideUp(300);

  // Toggle clicked FAQ item
//   $clickedTitle.toggleClass("show");
//   $clickedContent.slideToggle(300);
// });

// PDP FAQ accordion
$(".legal-content.faq h3").click(function () {
  var $clickedTitle = $(this);
  var $clickedContent = $clickedTitle.nextUntil("h3");

  $(".legal-content.faq h3").not($clickedTitle).removeClass("show");

  $(".legal-content.faq h3").not($clickedTitle).each(function () {
    $(this).nextUntil("h3").stop(true, true).slideUp(300);
  });

  $clickedTitle.toggleClass("show");
  $clickedContent.stop(true, true).slideToggle(300);
});
  
  // QTY PRODUCT
  $( ".minus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) - 1;
    if (getValue > 0) {
      $("#qty").val(getValue);
      $("#qty").attr("value", getValue);
    }
  });
  $( ".plus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) + 1;
    $("#qty").val(getValue);
    $("#qty").attr("value", getValue);
  });
  
  // ADD/REMOVE ITEM
  setTimeout(function(){
    /*$('.cart-product-quantity').each(function() {
      var elplus = $(this).find('.plus'),
          elminus = $(this).find('.minus'),
          quantity = $(this).find('input').val(),
          quentityDiv = $(this).find('.quantity-wrap');
      quentityDiv.text(quantity);
      $(this).on('click', '.plus', function(e) {
        incrementValue(e);
      });
      $(this).on('click', '.minus', function(e) {
        decrementValue(e);
      });
    });*/
    $(document).on('click',  '.plus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        incrementValue(e);
    });  
    $(document).on('click',  '.minus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        decrementValue(e);
    });  
  }, 20);
  // UPDATE CART COUNT
  function updateCartCount() {
    jQuery.getJSON('/cart.js', function(cart) {
      let itemscount = cart.item_count;
      var totalmoney = cart.total_price;
      totalmoney = totalmoney.toString().slice(0,-2);
      var len = totalmoney.length;
      var x = totalmoney.substring(0, len-3) + "," + totalmoney.substring(len-3);
      if(len < 4){
        $("#total-price-minicart").text("$" + totalmoney);
      } else {
        $("#total-price-minicart").text("$" + x);
      }
      if(itemscount == 0){
        $("#mini-cart").removeClass("active");
        $("#cart-trigger").addClass("disabled");
      } else {
        $("#cart-trigger").removeClass("disabled");
      }
      $("#cart-trigger-number").text(itemscount);
    });
  }
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    var maxinv = $(e.target).data("inventory")
    console.log(maxinv);

    if(currentVal >= maxinv) {
      console.log("No more stock");
    } else {
      if (!isNaN(currentVal)) {
        parent.find('input[name="updates[]"]').val(currentVal + 1);
        parent.find('.quantity-wrap').text(currentVal + 1);
        jQuery.post('/cart/change.js', {
          quantity: currentVal + 1,
          id: id
        });
      } else {
        parent.find('input[name="updates[]"]').val(0);
        parent.find('.quantity-wrap').text(0);
        jQuery.post('/cart/change.js', {
          quantity: 0,
          id: id
        });
      }
    }
    
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var cartitem = $(e.target).closest(".mini-cart-item");
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    
    if (!isNaN(currentVal) && currentVal > 1) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
      parent.find('.quantity-wrap').text(currentVal - 1);
      jQuery.post('/cart/change.js', {
        quantity: currentVal - 1,
        id: id
      });
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find('.quantity-wrap').text(0);
      jQuery.post('/cart/change.js', {
        quantity: 0,
        id: id
      });
      cartitem.remove();
    }
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // PDP MOBILE
  // $( ".collapse-mobile" ).click(function() {
  //   $("#product-info").toggleClass("hide");
  // });
  
  // PDP MOBILE
$(".collapse-mobile").click(function () {
  var $productInfo = $("#product-info");
  var $content = $("#variants-container, #product-add, #product-details");

  if ($productInfo.hasClass("hide")) {
    $productInfo.removeClass("hide");
    $content.stop(true, true).hide().slideDown(300);
  } else {
    $content.stop(true, true).slideUp(300, function () {
      $productInfo.addClass("hide");
    });
  }
});


  // TOGGLE MINICART
  $( ".close-cart" ).click(function() {
    $( "#mini-cart" ).removeClass("active");
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).removeClass("active");
    $("body").removeClass("black-menu");
    $("body").removeClass("cart-active");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
  });
  $( "#cart-trigger" ).click(function() {
    $( "#mini-cart" ).toggleClass("active");
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).toggleClass("active");
    $("body").toggleClass("cart-active");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
    $( "#menu-shop" ).removeClass("active");
    $("menu").removeClass("show");
    $("#header").removeClass("active-submenu");
  });

  // SELECT TO RADIO BUTTON
  $('.product-select-homepage').each(function(i, select){
      var $select = $(select);
      $select.find('option').each(function(j, option){
          var $option = $(option);
          // Create a radio
          var $radio = $('<input type="radio" />');
          // Set name and value:
          $radio.attr('name', $select.attr('name')).attr('value', $option.val()).attr('class', 'variant-input');
          // Set checked if the option was selected
          if ($option.attr('selected')) $radio.attr('checked', 'checked').addClass('checked-variant');
          // Set sold-out class if sold-out class was there
          if ( $($option).is( ".sold-out-variant" ) ) {
            $radio.addClass('sold-out-variant').prop( "disabled", true );
          }
          // Insert radio before select box
          $select.before($radio);
          // Insert a label
          $select.before(
            $("<label />").attr('class', 'variant-input-label').attr('for', $select.attr('name')).text($option.text())
          );
      });
      $select.remove();
  });

  // REMOVE SOLD OUT
  setTimeout(function(){
    $( ".variant-input-label" ).each(function( index ) {
      var text = $(this).text();
      $(this).text(text.replace('-sold-out', ''));         
    });
  }, 300);

  // SELECT SIZE
  setTimeout(function(){
    $( ".variant-input" ).each(function( index ) {
      if ( $(this).is( ".checked-variant" ) ) {
        $(this).next().addClass("selected-size-label");
      }
      if ( $(this).is( ".sold-out-variant" ) ) {
        $(this).next().addClass("sold-out-variant-label-last");
      }
    });
    $( ".variant-input-label" ).click(function() {
      $(this).prev().prop( "checked", true );
      $(this).parent().children( ".variant-input-label" ).removeClass("selected-size-label");
      $(this).parent().parent().children(".product-add").children(".addtoca").removeClass("unavailable");
      $(this).addClass("selected-size-label");
    });
  }, 200);

  // DETAILS
  // $( ".detail-trigger" ).click(function() {
  //   $(this).next(".detail-content").toggle();
  //   $(this).toggleClass("active");
  //   $( ".detail-trigger" ).not($(this)).removeClass("active");
  //   $( ".detail-content" ).not($(this).next(".detail-content")).hide();
  // });
  
  // DETAILS
  $(".detail-trigger").click(function () {
    var $this = $(this);
    var $content = $this.next(".detail-content");

    $(".detail-trigger").not($this).removeClass("active");
    $(".detail-content")
      .not($content)
      .stop(true, true)
      .slideUp(300);

    $this.toggleClass("active");
    $content
      .stop(true, true)
      .slideToggle(300);
  });

  // HOVER SHOP MENU
  /*$( "#menu-shop" ).click(function() {
    event.preventDefault();
    $(this).toggleClass("active");
    $("menu").toggleClass("show");
    $("#header").toggleClass("active-submenu");
    $("body").removeClass("cart-active");
    $("#mini-cart").removeClass("active");
  });*/
  // $( ".mobile-submenu-trigger" ).click(function() {
  //   event.preventDefault();
  //   $(this).toggleClass("active");
  //   $(this).next(".submenu-mobile-container").slideToggle();
  // });

   $(".mobile-submenu-trigger").click(function (event) {
    event.preventDefault();
    $(this).toggleClass("active");
    $(this).next(".submenu-mobile-container").slideToggle();
  });
  // $( ".has-children" ).hover(
  //   function() {
  //     var handle = $(this).data("handle");
  //     $(this).addClass("active");
  //     $("#sub-menu-" + handle).addClass("show");
  //     $("#header").addClass("active-submenu");
  //     $("body").removeClass("cart-active");
  //     $("#mini-cart").removeClass("active");
  //   }, function() {
  //     $(".menu-link").removeClass("active");
  //     $(".submenu-container").removeClass("show");
  //     $("#header").removeClass("active-submenu");
  //   }
  // );
  // $( "menu" ).hover(
  //   function() {
  //     $(this).addClass("show");
  //     $("#header").addClass("active-submenu");
  //     $("body").removeClass("cart-active");
  //     $("#mini-cart").removeClass("active");
  //   }, function() {
  //     $(".menu-link").removeClass("active");
  //     $(".submenu-container").removeClass("show");
  //     $("#header").removeClass("active-submenu");
  //   }
  // );

// --- Clean, resilient hover handler ---
let submenuTimer;

$(".has-children").on("mouseenter", function () {
  clearTimeout(submenuTimer);

  const handle = $(this).data("handle");
  const submenu = $("#sub-menu-" + handle);

  // Close any other menus first
  $(".menu-link.has-children").not(this).removeClass("active");
  $(".submenu-container").not(submenu).removeClass("show");

  // Activate current
  $(this).addClass("active");
  submenu.addClass("show");
  $("#header").addClass("active-submenu");
});

$(".has-children").on("mouseleave", function () {
  const handle = $(this).data("handle");
  const submenu = $("#sub-menu-" + handle);

  submenuTimer = setTimeout(() => {
    $(this).removeClass("active");
    submenu.removeClass("show");
    $("#header").removeClass("active-submenu");
  }, 250);
});

$(".submenu-container").on("mouseenter", function () {
  clearTimeout(submenuTimer);
  $(this).addClass("show");
  $("#header").addClass("active-submenu");
});

$(".submenu-container").on("mouseleave", function () {
  const $this = $(this);
  submenuTimer = setTimeout(() => {
    $(".menu-link.has-children").removeClass("active");
    $this.removeClass("show");
    $("#header").removeClass("active-submenu");
  }, 250);
});


  // ==============================
  // SCROLL LOGIC FOR Z-INDEX FIX
  // ==============================
  const header = document.querySelector("header");
  const productForm = document.querySelector("#product-form");

  window.addEventListener("scroll", () => {
    if (window.scrollY > 5) {
      document.body.classList.add("scrolled");
      if (header) header.classList.add("scrolled");
      if (productForm) productForm.classList.remove("active");
    } else {
      document.body.classList.remove("scrolled");
      if (header) header.classList.remove("scrolled");
    }
  });

});

const windowHeight = document.documentElement.clientHeight;
document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`); 
$( window ).on( "resize", function() {
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`); 
});



$( window ).on( "load", function() {
  if($(".marquee3k").length){
    Marquee3k.init({
      selector: 'marquee3k',
    });        
  }
  // Select the target node
  var target = $('.swym-wishlist-detail-content')[0]; // Make sure to replace 'yourDivId' with the actual ID of your div
  
  // Create an observer instance
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if( $('.react-swipeable-view-container div[aria-hidden="false"] a.swym-more-details-btn').length ){
        var href = $('.react-swipeable-view-container div[aria-hidden="false"] a.swym-more-details-btn').attr("href");
        console.log("HAY LINK", href);   
        window.location.href = href;
      } else {
        console.log("NO HAY LINK");
      }
      // You can add your own logic here to respond to the mutation
    });
  });
  var config = { 
    attributes: true, 
    childList: true, 
    characterData: true,
    subtree: true
  };
  if(target){
    observer.observe(target, config);
  }
});

  // NEW NAV SEARCH
  document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.search-wrapper');
  const toggle = document.querySelector('.search-toggle');
  const input = document.querySelector('.search-input');

  if (toggle && wrapper) {
    toggle.addEventListener('click', function () {
      wrapper.classList.toggle('active');
      if (wrapper.classList.contains('active')) {
        setTimeout(() => input.focus(), 150);
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove('active');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        wrapper.classList.remove('active');
      }
    });
  }
});

// document.querySelector('#load-more')?.addEventListener('click', async (e) => {
//   const btn = e.currentTarget;
//   btn.disabled = true;

//   try {
//     const res = await fetch(btn.dataset.next);
//     const html = await res.text();
//     const dom = new DOMParser().parseFromString(html, 'text/html');

//     const grid = document.querySelector('.collection-grid');
//     dom.querySelectorAll('.collection-grid .product').forEach(el => grid.appendChild(el));

//     // update next url or remove button
//     const nextBtn = dom.querySelector('#load-more');
//     if (nextBtn && nextBtn.dataset.next) {
//       btn.dataset.next = nextBtn.dataset.next;
//       btn.disabled = false;
//     } else {
//       btn.remove();
//     }

//     // re-init any per-card JS
//     window.initProductCards?.(grid);
//   } catch (err) {
//     btn.disabled = false;
//     console.error(err);
//   }
// });


document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector(".collection-grid");
  const loadMoreBtn = document.querySelector("#load-more");

  if (!grid || !loadMoreBtn) return;

  loadMoreBtn.addEventListener("click", async (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    btn.disabled = true;
    btn.textContent = "Loading...";

    try {
      const res = await fetch(btn.dataset.next);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      // Get the next batch of products only
      const newProducts = doc.querySelectorAll(".collection-grid .product");
      newProducts.forEach((p) => grid.appendChild(p));

      // Get new next-page URL, if exists
      const nextBtn = doc.querySelector("#load-more");
      if (nextBtn && nextBtn.dataset.next) {
        btn.dataset.next = nextBtn.dataset.next;
        btn.disabled = false;
        btn.textContent = "Load More";
      } else {
        btn.remove(); // no more pages
      }

      // Re-initialise per-product scripts
      if (window.initProductCards) window.initProductCards(grid);

      // Re-trigger lazy images if you’re using any
      if (window.lazySizes) lazySizes.loader.unveilDom(grid);

    } catch (err) {
      console.error("Load more failed:", err);
      btn.disabled = false;
      btn.textContent = "Load More";
    }
  });
});

window.initProductCards = function (scope = document) {
  const $scope = $(scope);

  /** -----------------------
   *  1. Swym wishlist sync
   * ----------------------- */
  if (window.SwymCallbacks && typeof SwymCallbacks.init === "function") {
    try { SwymCallbacks.init(); } catch (e) {}
  } else if (Array.isArray(window.SwymCallbacks)) {
    // if Swym hasn't fully loaded yet, queue the init
    window.SwymCallbacks.push(function() {
      try { SwymCallbacks.init(); } catch(e) {}
    });
  }

  // Mark previously-added wishlist hearts
  $scope.find(".swym-heart").each(function () {
    if ($(this).hasClass("swym-added")) {
      $(this).addClass("previously-added");
    }
  });

  /** -----------------------
   *  2. Quick-buy selects
   * ----------------------- */
  $scope.find(".product-select-homepage")
    .off("change")
    .on("change", function () {
      $(this).closest("form").find(".addtoca").removeClass("unavailable");
    });

  /** -----------------------
   *  3. Filters & sorting (delegated)
   * ----------------------- */
  $(document)
    .off("click.collectionFilters")
    .on("click.collectionFilters", ".filter", function () {
      $(this).toggleClass("selected");
      const selectedTags = $(".filter.selected")
        .map(function () {
          return $(this).data("tag");
        })
        .get();

      if (selectedTags.length === 0) {
        $(".product").removeClass("hidden");
      } else {
        $(".product").addClass("hidden");
        for (let i = 0; i < selectedTags.length; i++) {
          $(".product.tag-" + selectedTags[i]).removeClass("hidden");
        }
      }
    });

  $(document)
    .off("click.collectionSizes")
    .on("click.collectionSizes", ".filter-size", function () {
      $(this).toggleClass("selected");
      const selectedSizes = $(".filter-size.selected")
        .map(function () {
          return $(this).data("size");
        })
        .get();

      if (selectedSizes.length === 0) {
        $(".product").removeClass("hidden");
      } else {
        $(".product").addClass("hidden");
        for (let i = 0; i < selectedSizes.length; i++) {
          $(".product[data-size*='" + selectedSizes[i] + "']").removeClass(
            "hidden"
          );
        }
      }
    });

  // ------------------------------
// Sort / Filter menu toggles
// ------------------------------
$(document)
  .off("click.sortMenu")
  .on("click.sortMenu", ".sort-by-trigger", function () {
    const $trigger = $(this);
    const $target = $("#collection-filter-sort-container");

    $trigger.toggleClass("selected");
    $target.toggleClass("show");

    const isOpen = $trigger.hasClass("selected");
    $trigger.find("span:first-child").toggle(!isOpen); // ↓
    $trigger.find("span:last-child").toggle(isOpen);   // ↑
  });

$(document)
  .off("click.sizeMenu")
  .on("click.sizeMenu", ".sort-by-size", function () {
    const $trigger = $(this);
    const $target = $("#collection-filter-sizes-container");

    $trigger.toggleClass("selected");
    $target.toggleClass("show");

    const isOpen = $trigger.hasClass("selected");
    $trigger.find("span:first-child").toggle(!isOpen);
    $trigger.find("span:last-child").toggle(isOpen);
  });

};
document.addEventListener("DOMContentLoaded", () => {
  window.initProductCards(document);
});



